import React from 'react';

interface WidgetPreviewBannerProps {
  message?: string;
}

const WidgetPreviewBanner: React.FC<WidgetPreviewBannerProps> = ({
  message = 'Sample data — asset assigned at runtime',
}) => (
  <div className="px-3 py-1 bg-warning-50 border-b border-warning-100">
    <span className="text-[10px] text-warning-600 uppercase tracking-wide font-medium">
      {message}
    </span>
  </div>
);

export default WidgetPreviewBanner;
